import { z } from 'zod';
import { PixelEventBaseSchema } from '../pixel-event.mjs';

var _EventType = /* @__PURE__ */ ((_EventType2) => {
  _EventType2["VIEW_LISTING_PAGE"] = "buyer_view_listing_page";
  _EventType2["OPEN_OFFER_FRAME"] = "buyer_open_offer_frame";
  _EventType2["VIEW_OFFER_HUB"] = "buyer_view_offer_hub";
  _EventType2["VIEW_LISTING_DOCUMENTS"] = "buyer_view_listing_documents";
  _EventType2["SWITCH_TO_SMS_LOGIN"] = "buyer_switch_to_sms_login";
  _EventType2["SWITCH_TO_EMAIL_LOGIN"] = "buyer_switch_to_email_login";
  _EventType2["RESEND_CODE"] = "buyer_resend-code";
  _EventType2["VIEW_LOGIN"] = "buyer_view_login";
  _EventType2["VIEW_LOGIN_VERIFY"] = "buyer_view_login_verify";
  _EventType2["VIEW_LOGIN_PHONE"] = "buyer_view_login_phone";
  _EventType2["VIEW_LOGIN_SMS_VALIDATE"] = "buyer_view_login_sms_validate";
  _EventType2["VIEW_LOGIN_REGISTER"] = "buyer_view_login_register";
  _EventType2["VIEW_LOGIN_QR_CODE"] = "buyer_view_login_qr_code";
  _EventType2["DOWNLOAD_QR_CODE"] = "buyer_download_qr_code";
  _EventType2["LOGIN"] = "buyer_login";
  _EventType2["LOGOUT"] = "buyer_logout";
  _EventType2["REGISTER"] = "buyer_register";
  _EventType2["VIEW_OFFER_OVERVIEW"] = "buyer_view_offer_overview";
  _EventType2["VIEW_OFFER_PROPERTY_AGENT_DETAILS"] = "buyer_view_offer_property_agent_details";
  _EventType2["VIEW_OFFER_AMOUNT"] = "buyer_view_offer_amount";
  _EventType2["VIEW_OFFER_SETTLEMENT"] = "buyer_view_offer_settlement";
  _EventType2["VIEW_OFFER_CONDITIONS"] = "buyer_view_offer_conditions";
  _EventType2["VIEW_OFFER_FINANCE"] = "buyer_view_offer_finance";
  _EventType2["VIEW_OFFER_CONVEYANCER"] = "buyer_view_offer_conveyancer";
  _EventType2["VIEW_OFFER_DOCUMENTS"] = "buyer_view_offer_documents";
  _EventType2["VIEW_OFFER_BUYERS"] = "buyer_view_offer_buyers";
  _EventType2["VIEW_OFFER_ADD_BUYER"] = "buyer_view_offer_add_buyer";
  _EventType2["VIEW_OFFER_ADD_BUYER_SMS_VALIDATE"] = "buyer_view_offer_add_buyer_sms_validate";
  _EventType2["VIEW_OFFER_BUYER"] = "buyer_view_offer_buyer";
  _EventType2["VIEW_OFFER_AGREEMENTS"] = "buyer_view_offer_agreements";
  _EventType2["VIEW_OFFER_SIGNATURE"] = "buyer_view_offer_signature";
  _EventType2["VIEW_OFFER_SELLING"] = "buyer_view_offer_selling";
  _EventType2["COMPLETE_OFFER_AMOUNT"] = "buyer_complete_offer_amount";
  _EventType2["COMPLETE_OFFER_SETTLEMENT"] = "buyer_complete_offer_settlement";
  _EventType2["ACCEPT_OFFER_CONDITION"] = "buyer_accept_offer_condition";
  _EventType2["REMOVE_OFFER_CONDITION"] = "buyer_remove_offer_condition";
  _EventType2["ADD_OFFER_EXPIRY"] = "buyer_add_offer_expiry";
  _EventType2["REMOVE_OFFER_EXPIRY"] = "buyer_remove_offer_expiry";
  _EventType2["COMPLETE_OFFER_CONDITIONS"] = "buyer_complete_offer_conditions";
  _EventType2["COMPLETE_OFFER_FINANCE"] = "buyer_complete_offer_finance";
  _EventType2["COMPLETE_OFFER_CONVEYANCER"] = "buyer_complete_offer_conveyancer";
  _EventType2["COMPLETE_OFFER_BUYER"] = "buyer_complete_offer_buyer";
  _EventType2["REMOVE_OFFER_BUYER"] = "buyer_remove_offer_buyer";
  _EventType2["COMPLETE_OFFER_SELLING"] = "buyer_complete_offer_selling";
  _EventType2["SUBMIT_OFFER"] = "buyer_submit_offer";
  _EventType2["UPDATE_OFFER"] = "buyer_update_offer";
  _EventType2["VIEW_PTB_OVERVIEW"] = "buyer_view_ptb_overview";
  _EventType2["VIEW_PTB_AMOUNT"] = "buyer_view_ptb_amount";
  _EventType2["VIEW_PTB_SETTLEMENT"] = "buyer_view_ptb_settlement";
  _EventType2["VIEW_PTB_CONDITIONS"] = "buyer_view_ptb_conditions";
  _EventType2["VIEW_PTB_FINANCE"] = "buyer_view_ptb_finance";
  _EventType2["VIEW_PTB_CONVEYANCER"] = "buyer_view_ptb_conveyancer";
  _EventType2["VIEW_PTB_DOCUMENTS"] = "buyer_view_ptb_documents";
  _EventType2["VIEW_PTB_BUYERS"] = "buyer_view_ptb_buyers";
  _EventType2["VIEW_PTB_ADD_BUYER"] = "buyer_view_ptb_add_buyer";
  _EventType2["VIEW_PTB_ADD_BUYER_SMS_VALIDATE"] = "buyer_view_ptb_add_buyer_sms_validate";
  _EventType2["VIEW_PTB_BUYER"] = "buyer_view_ptb_buyer";
  _EventType2["UPGRADE_PTB_TO_OFFER"] = "buyer_upgrade_ptb_to_offer";
  _EventType2["DOWNLOAD_DOCUMENT"] = "buyer_download_document";
  _EventType2["BUYER_START_SESSION"] = "buyer-start-session";
  _EventType2["CLAIM_LITE_OFFER"] = "buyer_claim_lite_offer";
  _EventType2["CLICK_BYB_CARD"] = "buyer_click_byb_card";
  return _EventType2;
})(_EventType || {});
var BuyerEvent;
((BuyerEvent2) => {
  BuyerEvent2.EventType = _EventType;
  const BaseSchema = PixelEventBaseSchema.extend({
    userId: z.string().optional(),
    listingId: z.string(),
    foreignId: z.string(),
    appId: z.string()
  });
  BuyerEvent2.ViewListingPageEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_listing_page" /* VIEW_LISTING_PAGE */)
  });
  BuyerEvent2.OpenOfferFrameEventSchema = BaseSchema.extend({
    type: z.literal("buyer_open_offer_frame" /* OPEN_OFFER_FRAME */)
  });
  BuyerEvent2.ViewOfferHubEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_hub" /* VIEW_OFFER_HUB */)
  });
  BuyerEvent2.ViewListingDocumentsEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_listing_documents" /* VIEW_LISTING_DOCUMENTS */)
  });
  BuyerEvent2.ViewLoginEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_login" /* VIEW_LOGIN */),
    channel: z.string()
  });
  BuyerEvent2.ViewLoginVerifyEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_login_verify" /* VIEW_LOGIN_VERIFY */),
    channel: z.string()
  });
  BuyerEvent2.SwitchToSmsLoginEventSchema = BaseSchema.extend({
    type: z.literal("buyer_switch_to_sms_login" /* SWITCH_TO_SMS_LOGIN */)
  });
  BuyerEvent2.SwitchToEmailLoginEventSchema = BaseSchema.extend({
    type: z.literal("buyer_switch_to_email_login" /* SWITCH_TO_EMAIL_LOGIN */)
  });
  BuyerEvent2.ResendCodeEventSchema = BaseSchema.extend({
    type: z.literal("buyer_resend-code" /* RESEND_CODE */),
    channel: z.string()
  });
  BuyerEvent2.ViewLoginPhoneEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_login_phone" /* VIEW_LOGIN_PHONE */)
  });
  BuyerEvent2.ViewLoginSmsValidateEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_login_sms_validate" /* VIEW_LOGIN_SMS_VALIDATE */)
  });
  BuyerEvent2.ViewLoginRegisterEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_login_register" /* VIEW_LOGIN_REGISTER */)
  });
  BuyerEvent2.ViewLoginQrCodeEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_login_qr_code" /* VIEW_LOGIN_QR_CODE */)
  });
  BuyerEvent2.DownloadQrCodeEventSchema = BaseSchema.extend({
    type: z.literal("buyer_download_qr_code" /* DOWNLOAD_QR_CODE */)
  });
  BuyerEvent2.LoginEventSchema = BaseSchema.extend({
    type: z.literal("buyer_login" /* LOGIN */)
  });
  BuyerEvent2.LogoutEventSchema = BaseSchema.extend({
    type: z.literal("buyer_logout" /* LOGOUT */)
  });
  BuyerEvent2.RegisterEventSchema = BaseSchema.extend({
    type: z.literal("buyer_register" /* REGISTER */),
    buyerId: z.string()
  });
  BuyerEvent2.ViewOfferOverviewEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_overview" /* VIEW_OFFER_OVERVIEW */)
  });
  BuyerEvent2.ViewOfferPropertyAgentDetailsEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_property_agent_details" /* VIEW_OFFER_PROPERTY_AGENT_DETAILS */)
  });
  BuyerEvent2.ViewOfferAmountEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_amount" /* VIEW_OFFER_AMOUNT */)
  });
  BuyerEvent2.ViewOfferSettlementEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_settlement" /* VIEW_OFFER_SETTLEMENT */)
  });
  BuyerEvent2.ViewOfferConditionsEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_conditions" /* VIEW_OFFER_CONDITIONS */)
  });
  BuyerEvent2.ViewOfferFinanceEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_finance" /* VIEW_OFFER_FINANCE */)
  });
  BuyerEvent2.ViewOfferConveyancerEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_conveyancer" /* VIEW_OFFER_CONVEYANCER */)
  });
  BuyerEvent2.ViewOfferDocumentsEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_documents" /* VIEW_OFFER_DOCUMENTS */)
  });
  BuyerEvent2.ViewOfferBuyersEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_buyers" /* VIEW_OFFER_BUYERS */)
  });
  BuyerEvent2.ViewOfferAddBuyerEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_add_buyer" /* VIEW_OFFER_ADD_BUYER */)
  });
  BuyerEvent2.ViewOfferAddBuyerSmsValidateEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_add_buyer_sms_validate" /* VIEW_OFFER_ADD_BUYER_SMS_VALIDATE */)
  });
  BuyerEvent2.ViewOfferBuyerEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_buyer" /* VIEW_OFFER_BUYER */)
  });
  BuyerEvent2.ViewOfferAgreementsEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_agreements" /* VIEW_OFFER_AGREEMENTS */)
  });
  BuyerEvent2.ViewOfferSignatureEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_signature" /* VIEW_OFFER_SIGNATURE */)
  });
  BuyerEvent2.ViewOfferSellingEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_offer_selling" /* VIEW_OFFER_SELLING */)
  });
  BuyerEvent2.CompleteOfferAmountEventSchema = BaseSchema.extend({
    type: z.literal("buyer_complete_offer_amount" /* COMPLETE_OFFER_AMOUNT */),
    amount: z.number()
  });
  BuyerEvent2.CompleteOfferSettlementEventSchema = BaseSchema.extend({
    type: z.literal("buyer_complete_offer_settlement" /* COMPLETE_OFFER_SETTLEMENT */),
    settlement: z.string()
  });
  BuyerEvent2.AcceptOfferConditionEventSchema = BaseSchema.extend({
    type: z.literal("buyer_accept_offer_condition" /* ACCEPT_OFFER_CONDITION */),
    conditionId: z.string(),
    conditionLine: z.string(),
    conditionRegion: z.string(),
    conditionParams: z.string().nullable()
  });
  BuyerEvent2.RemoveOfferConditionEventSchema = BaseSchema.extend({
    type: z.literal("buyer_remove_offer_condition" /* REMOVE_OFFER_CONDITION */),
    conditionName: z.string(),
    conditionRegion: z.string()
  });
  BuyerEvent2.AddOfferExpiryEventSchema = BaseSchema.extend({
    type: z.literal("buyer_add_offer_expiry" /* ADD_OFFER_EXPIRY */),
    expiry: z.string()
  });
  BuyerEvent2.RemoveOfferExpiryEventSchema = BaseSchema.extend({
    type: z.literal("buyer_remove_offer_expiry" /* REMOVE_OFFER_EXPIRY */)
  });
  BuyerEvent2.CompleteOfferConditionsEventSchema = BaseSchema.extend({
    type: z.literal("buyer_complete_offer_conditions" /* COMPLETE_OFFER_CONDITIONS */)
  });
  BuyerEvent2.CompleteOfferFinanceEventSchema = BaseSchema.extend({
    type: z.literal("buyer_complete_offer_finance" /* COMPLETE_OFFER_FINANCE */),
    financeType: z.string(),
    financeInstitution: z.string().nullable(),
    financeDate: z.string().nullable(),
    financeNote: z.string().nullable()
  });
  BuyerEvent2.CompleteOfferConveyancerEventSchema = BaseSchema.extend({
    type: z.literal("buyer_complete_offer_conveyancer" /* COMPLETE_OFFER_CONVEYANCER */),
    conveyancerType: z.string(),
    conveyancerName: z.string().nullable(),
    conveyancerEmail: z.string().nullable().default(null),
    conveyancerPhone: z.string().nullable(),
    conveyancerCompany: z.string().nullable().default(null),
    conveyancerReferralEnabled: z.boolean()
  });
  BuyerEvent2.CompleteOfferBuyerEventSchema = BaseSchema.extend({
    type: z.literal("buyer_complete_offer_buyer" /* COMPLETE_OFFER_BUYER */),
    buyerId: z.string().nullable()
  });
  BuyerEvent2.RemoveOfferBuyerEventSchema = BaseSchema.extend({
    type: z.literal("buyer_remove_offer_buyer" /* REMOVE_OFFER_BUYER */),
    buyerId: z.string().nullable()
  });
  BuyerEvent2.CompleteOfferSellingEventSchema = BaseSchema.extend({
    type: z.literal("buyer_complete_offer_selling" /* COMPLETE_OFFER_SELLING */),
    situation: z.string()
  });
  BuyerEvent2.SubmitOfferEventSchema = BaseSchema.extend({
    type: z.literal("buyer_submit_offer" /* SUBMIT_OFFER */)
  });
  BuyerEvent2.UpdateOfferEventSchema = BaseSchema.extend({
    type: z.literal("buyer_update_offer" /* UPDATE_OFFER */)
  });
  BuyerEvent2.ViewPtbOverviewEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_overview" /* VIEW_PTB_OVERVIEW */)
  });
  BuyerEvent2.ViewPtbAmountEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_amount" /* VIEW_PTB_AMOUNT */)
  });
  BuyerEvent2.ViewPtbSettlementEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_settlement" /* VIEW_PTB_SETTLEMENT */)
  });
  BuyerEvent2.ViewPtbConditionsEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_conditions" /* VIEW_PTB_CONDITIONS */)
  });
  BuyerEvent2.ViewPtbFinanceEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_finance" /* VIEW_PTB_FINANCE */)
  });
  BuyerEvent2.ViewPtbConveyancerEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_conveyancer" /* VIEW_PTB_CONVEYANCER */)
  });
  BuyerEvent2.ViewPtbDocumentsEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_documents" /* VIEW_PTB_DOCUMENTS */)
  });
  BuyerEvent2.ViewPtbBuyersEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_buyers" /* VIEW_PTB_BUYERS */)
  });
  BuyerEvent2.ViewPtbAddBuyerEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_add_buyer" /* VIEW_PTB_ADD_BUYER */)
  });
  BuyerEvent2.ViewPtbAddBuyerSmsValidateEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_add_buyer_sms_validate" /* VIEW_PTB_ADD_BUYER_SMS_VALIDATE */)
  });
  BuyerEvent2.ViewPtbBuyerEventSchema = BaseSchema.extend({
    type: z.literal("buyer_view_ptb_buyer" /* VIEW_PTB_BUYER */)
  });
  BuyerEvent2.UpgradePtbToOfferEventSchema = BaseSchema.extend({
    type: z.literal("buyer_upgrade_ptb_to_offer" /* UPGRADE_PTB_TO_OFFER */)
  });
  BuyerEvent2.DownloadDocumentEventSchema = BaseSchema.extend({
    type: z.literal("buyer_download_document" /* DOWNLOAD_DOCUMENT */),
    documentId: z.string(),
    documentUrl: z.string(),
    documentType: z.string()
  });
  BuyerEvent2.BuyerStartSessionEventSchema = BaseSchema.extend({
    type: z.literal("buyer-start-session" /* BUYER_START_SESSION */),
    buyerId: z.string()
  });
  BuyerEvent2.ClaimLiteOfferEventSchema = BaseSchema.extend({
    type: z.literal("buyer_claim_lite_offer" /* CLAIM_LITE_OFFER */),
    liteOfferId: z.string()
  });
  BuyerEvent2.ClickBYBCardEventSchema = BaseSchema.extend({
    type: z.literal("buyer_click_byb_card" /* CLICK_BYB_CARD */)
  });
  BuyerEvent2.Validators = {
    ["buyer_view_listing_page" /* VIEW_LISTING_PAGE */]: BuyerEvent2.ViewListingPageEventSchema,
    ["buyer_open_offer_frame" /* OPEN_OFFER_FRAME */]: BuyerEvent2.OpenOfferFrameEventSchema,
    ["buyer_view_offer_hub" /* VIEW_OFFER_HUB */]: BuyerEvent2.ViewOfferHubEventSchema,
    ["buyer_view_listing_documents" /* VIEW_LISTING_DOCUMENTS */]: BuyerEvent2.ViewListingDocumentsEventSchema,
    // Log in events
    ["buyer_view_login" /* VIEW_LOGIN */]: BuyerEvent2.ViewLoginEventSchema,
    ["buyer_view_login_verify" /* VIEW_LOGIN_VERIFY */]: BuyerEvent2.ViewLoginVerifyEventSchema,
    ["buyer_switch_to_email_login" /* SWITCH_TO_EMAIL_LOGIN */]: BuyerEvent2.SwitchToEmailLoginEventSchema,
    ["buyer_switch_to_sms_login" /* SWITCH_TO_SMS_LOGIN */]: BuyerEvent2.SwitchToSmsLoginEventSchema,
    ["buyer_resend-code" /* RESEND_CODE */]: BuyerEvent2.ResendCodeEventSchema,
    ["buyer_view_login_phone" /* VIEW_LOGIN_PHONE */]: BuyerEvent2.ViewLoginPhoneEventSchema,
    ["buyer_view_login_sms_validate" /* VIEW_LOGIN_SMS_VALIDATE */]: BuyerEvent2.ViewLoginSmsValidateEventSchema,
    ["buyer_view_login_register" /* VIEW_LOGIN_REGISTER */]: BuyerEvent2.ViewLoginRegisterEventSchema,
    ["buyer_view_login_qr_code" /* VIEW_LOGIN_QR_CODE */]: BuyerEvent2.ViewLoginQrCodeEventSchema,
    ["buyer_download_qr_code" /* DOWNLOAD_QR_CODE */]: BuyerEvent2.DownloadQrCodeEventSchema,
    ["buyer_login" /* LOGIN */]: BuyerEvent2.LoginEventSchema,
    ["buyer_logout" /* LOGOUT */]: BuyerEvent2.LogoutEventSchema,
    ["buyer_register" /* REGISTER */]: BuyerEvent2.RegisterEventSchema,
    // Make an offer event types
    ["buyer_view_offer_overview" /* VIEW_OFFER_OVERVIEW */]: BuyerEvent2.ViewOfferOverviewEventSchema,
    ["buyer_view_offer_property_agent_details" /* VIEW_OFFER_PROPERTY_AGENT_DETAILS */]: BuyerEvent2.ViewOfferPropertyAgentDetailsEventSchema,
    ["buyer_view_offer_amount" /* VIEW_OFFER_AMOUNT */]: BuyerEvent2.ViewOfferAmountEventSchema,
    ["buyer_view_offer_settlement" /* VIEW_OFFER_SETTLEMENT */]: BuyerEvent2.ViewOfferSettlementEventSchema,
    ["buyer_view_offer_conditions" /* VIEW_OFFER_CONDITIONS */]: BuyerEvent2.ViewOfferConditionsEventSchema,
    ["buyer_view_offer_finance" /* VIEW_OFFER_FINANCE */]: BuyerEvent2.ViewOfferFinanceEventSchema,
    ["buyer_view_offer_conveyancer" /* VIEW_OFFER_CONVEYANCER */]: BuyerEvent2.ViewOfferConveyancerEventSchema,
    ["buyer_view_offer_documents" /* VIEW_OFFER_DOCUMENTS */]: BuyerEvent2.ViewOfferDocumentsEventSchema,
    ["buyer_view_offer_buyer" /* VIEW_OFFER_BUYER */]: BuyerEvent2.ViewOfferBuyerEventSchema,
    ["buyer_view_offer_add_buyer" /* VIEW_OFFER_ADD_BUYER */]: BuyerEvent2.ViewOfferAddBuyerEventSchema,
    ["buyer_view_offer_add_buyer_sms_validate" /* VIEW_OFFER_ADD_BUYER_SMS_VALIDATE */]: BuyerEvent2.ViewOfferAddBuyerSmsValidateEventSchema,
    ["buyer_view_offer_buyers" /* VIEW_OFFER_BUYERS */]: BuyerEvent2.ViewOfferBuyersEventSchema,
    ["buyer_view_offer_agreements" /* VIEW_OFFER_AGREEMENTS */]: BuyerEvent2.ViewOfferAgreementsEventSchema,
    ["buyer_view_offer_signature" /* VIEW_OFFER_SIGNATURE */]: BuyerEvent2.ViewOfferSignatureEventSchema,
    ["buyer_view_offer_selling" /* VIEW_OFFER_SELLING */]: BuyerEvent2.ViewOfferSellingEventSchema,
    ["buyer_complete_offer_amount" /* COMPLETE_OFFER_AMOUNT */]: BuyerEvent2.CompleteOfferAmountEventSchema,
    ["buyer_complete_offer_settlement" /* COMPLETE_OFFER_SETTLEMENT */]: BuyerEvent2.CompleteOfferSettlementEventSchema,
    ["buyer_accept_offer_condition" /* ACCEPT_OFFER_CONDITION */]: BuyerEvent2.AcceptOfferConditionEventSchema,
    ["buyer_remove_offer_condition" /* REMOVE_OFFER_CONDITION */]: BuyerEvent2.RemoveOfferConditionEventSchema,
    ["buyer_add_offer_expiry" /* ADD_OFFER_EXPIRY */]: BuyerEvent2.AddOfferExpiryEventSchema,
    ["buyer_remove_offer_expiry" /* REMOVE_OFFER_EXPIRY */]: BuyerEvent2.RemoveOfferExpiryEventSchema,
    ["buyer_complete_offer_conditions" /* COMPLETE_OFFER_CONDITIONS */]: BuyerEvent2.CompleteOfferConditionsEventSchema,
    ["buyer_complete_offer_finance" /* COMPLETE_OFFER_FINANCE */]: BuyerEvent2.CompleteOfferFinanceEventSchema,
    ["buyer_complete_offer_conveyancer" /* COMPLETE_OFFER_CONVEYANCER */]: BuyerEvent2.CompleteOfferConveyancerEventSchema,
    ["buyer_complete_offer_buyer" /* COMPLETE_OFFER_BUYER */]: BuyerEvent2.CompleteOfferBuyerEventSchema,
    ["buyer_remove_offer_buyer" /* REMOVE_OFFER_BUYER */]: BuyerEvent2.RemoveOfferBuyerEventSchema,
    ["buyer_complete_offer_selling" /* COMPLETE_OFFER_SELLING */]: BuyerEvent2.CompleteOfferSellingEventSchema,
    ["buyer_submit_offer" /* SUBMIT_OFFER */]: BuyerEvent2.SubmitOfferEventSchema,
    ["buyer_update_offer" /* UPDATE_OFFER */]: BuyerEvent2.UpdateOfferEventSchema,
    // Prepare to buy events
    ["buyer_view_ptb_overview" /* VIEW_PTB_OVERVIEW */]: BuyerEvent2.ViewPtbOverviewEventSchema,
    ["buyer_view_ptb_amount" /* VIEW_PTB_AMOUNT */]: BuyerEvent2.ViewPtbAmountEventSchema,
    ["buyer_view_ptb_settlement" /* VIEW_PTB_SETTLEMENT */]: BuyerEvent2.ViewPtbSettlementEventSchema,
    ["buyer_view_ptb_conditions" /* VIEW_PTB_CONDITIONS */]: BuyerEvent2.ViewPtbConditionsEventSchema,
    ["buyer_view_ptb_finance" /* VIEW_PTB_FINANCE */]: BuyerEvent2.ViewPtbFinanceEventSchema,
    ["buyer_view_ptb_conveyancer" /* VIEW_PTB_CONVEYANCER */]: BuyerEvent2.ViewPtbConveyancerEventSchema,
    ["buyer_view_ptb_documents" /* VIEW_PTB_DOCUMENTS */]: BuyerEvent2.ViewPtbDocumentsEventSchema,
    ["buyer_view_ptb_buyers" /* VIEW_PTB_BUYERS */]: BuyerEvent2.ViewPtbBuyersEventSchema,
    ["buyer_view_ptb_add_buyer" /* VIEW_PTB_ADD_BUYER */]: BuyerEvent2.ViewPtbAddBuyerEventSchema,
    ["buyer_view_ptb_add_buyer_sms_validate" /* VIEW_PTB_ADD_BUYER_SMS_VALIDATE */]: BuyerEvent2.ViewPtbAddBuyerSmsValidateEventSchema,
    ["buyer_view_ptb_buyer" /* VIEW_PTB_BUYER */]: BuyerEvent2.ViewPtbBuyerEventSchema,
    ["buyer_upgrade_ptb_to_offer" /* UPGRADE_PTB_TO_OFFER */]: BuyerEvent2.UpgradePtbToOfferEventSchema,
    ["buyer_download_document" /* DOWNLOAD_DOCUMENT */]: BuyerEvent2.DownloadDocumentEventSchema,
    ["buyer-start-session" /* BUYER_START_SESSION */]: BuyerEvent2.BuyerStartSessionEventSchema,
    // Lite offer events
    ["buyer_claim_lite_offer" /* CLAIM_LITE_OFFER */]: BuyerEvent2.ClaimLiteOfferEventSchema,
    ["buyer_click_byb_card" /* CLICK_BYB_CARD */]: BuyerEvent2.ClickBYBCardEventSchema
  };
})(BuyerEvent || (BuyerEvent = {}));

export { BuyerEvent, _EventType };
